module.exports = __webpack_public_path__ + "static/media/Y6.89a1056a.mp3";